<template>
  <el-container>
      <el-header style="padding:15px;">
        <el-container>
          <el-aside width="">
            <el-page-header @back="goBack">
            </el-page-header>
          </el-aside>
          <el-main style="margin:0px;padding:0px;margin-top:0px;overflow:hidden;">
            <el-row type="flex" align="middle" :gutter="20" v-if="this.formid || '' != ''">
   
              <el-col>
                {{this.forminfo.name}}


                <el-link icon="el-icon-notebook-2" 
                  @click="$router.push({ path: '/form/data', query:{id: formid,category:forminfo.category}})" 
                  :underline="false" style="font-size:20px;padding-right:8px"
                  v-if="forminfo.category == 'PROJECT'">
                </el-link>
                <el-link icon="el-icon-s-grid" 
                  @click="$router.push({ path: '/form/grid', query:{id: formid,category:forminfo.category}})" 
                  :underline="false" style="font-size:20px;padding-right:8px">
                </el-link>
                <el-link icon="el-icon-edit" 
                  @click="$router.push({ path: '/form/edit', query:{id: formid,category:forminfo.category}})" 
                  :underline="false" style="font-size:20px;padding-right:8px">
                </el-link>



                   <el-popover
                    v-model="taginputvisible"
                    placement="bottom"
                    width="400"
                    trigger="click">
                    <div>
                      


                      <i class="fa fa-tags"></i>已选标签
                      <div style="border:0px solid #aabbcc;padding:0px;">
                      <!-- <el-divider content-position="left">已选标签</el-divider> -->
                        <span v-if="(forminfo.tags || []).length !=0">
                          <el-tag 
                            style="margin-left:3px;"
                            
                            size="mini"  
                            v-for="(item,index) in forminfo.tags.split(',')" 
                            closable
                            :disable-transitions="false"
                            @close="handleTagClose(item)"
                            :key="index">{{item}}
                          </el-tag>
                        </span>
                        <div style="padding-top:8px;padding-right:8px;">
                          <el-input
                          v-model="taginputvalue"
                          size="media"
                          placeholder="标入标签，回车确认"
                          clearable
                          @keyup.enter.native="submitTag"
                          />
                        </div>
                      </div>
                      <br>
                      <i class="fa fa-tags"></i>我的标签库
                      <div style="border:0px solid #aabbcc;padding:0px;">
                      <!-- <el-divider content-position="left">我的标签库</el-divider> -->
                        <el-tag
                          :key="index"
                          v-for="(tag,index) in tagtemplates.mytags.filter(data=>!this.taginputvalue
                            || data.tagname.toLowerCase().includes(this.taginputvalue.toLowerCase())
                            )"
                          :disable-transitions="false"
                          @click="selectTag(tag.tagname)"
                          style="cursor:pointer;margin:3px;"
                          effect="plain"
                        >
                          {{tag.tagname}}{{tag.num>0?'('+tag.num+')':''}}
                        </el-tag>
                      </div>
                      <br>
                      <i class="fa fa-tags"></i>ICD-11
                      <div style="border:0px solid #aabbcc;padding:0px;">
                        <!-- <el-divider content-position="left">ICD-11</el-divider> -->
                        <!-- <div style="height:300px;">
                        <el-tag
                          v-if="taginputvalue !== ''"
                          :key="index"
                          v-for="(tag,index) in tagtemplates.icd11.filter(data=>!this.taginputvalue
                            || data.tagname.toLowerCase().includes(this.taginputvalue.toLowerCase())
                            )"
                          :disable-transitions="false"
                          @click="selectTag(tag.tagname)"
                          style="cursor:pointer;margin:3px;"
                          effect="plain"
                        >
                          {{tag.tagname}}
                        </el-tag>
                        </div> -->
                        <el-table 
                          :data="tagtemplates.icd11.filter(data=> this.taginputvalue &&
                                                      data.tagname.toLowerCase().includes(this.taginputvalue.toLowerCase())
                                                      )" 
                          :show-header="true" 
                          max-height="310px"
                          @row-click="selectTagTable">
                            <el-table-column prop="name" label="疾病名称">
                              <template slot-scope="scope">
                                {{scope.row.tagname}}
                              </template>
                            </el-table-column>
                            <el-table-column prop="name" label="编码" width="80px;">
                              <template slot-scope="scope">
                                {{scope.row.tagid}}
                              </template>
                            </el-table-column>
                        </el-table>
                      </div>
                    </div>
                    <el-link slot="reference" class="el-icon-circle-plus-outline"
                    style="font-size:20px;" :underline="false">
                    </el-link>
                    <!-- <i slot="reference" class='el-icon-plus' style="font-size:16px;"></i> -->
                  </el-popover>
                  

                  <span v-if="(forminfo.tags || []).length !=0">
                    <el-tag 
                      style="margin-left:3px;"
                      
                      size="mini"  
                      v-for="(item,index) in forminfo.tags.split(',')" 
                      
                      :disable-transitions="false"
                
                      :key="index">{{item}}
                    </el-tag>
                  </span>
                

              </el-col>
             
            </el-row>
          </el-main>
        </el-container>
        
      </el-header>
      <el-main style="padding:5px;">
        <router-view :key="$route.fullPath"></router-view>
      </el-main>
    </el-container>
</template>

<script>
export default {
    data() {
      return {
        formid:this.$route.query.id,
        category:this.$route.query.category,
        forminfo:{},
        taginputvalue:"",
        taginputvisible:false,
        tagtemplates:{
          mytags:[],
          icd11:[],
        },
      }
    },
    created() {
      
    },
    watch:{
      taginputvisible(val){
        if(val){
          if(this.tagtemplates.icd11.length == 0){
            this.getTagList();
            this.getTagTemplateList();
          }
        }
      }
    },
    mounted() {
      this.getInfo(this.formid);
    },
    methods: {
      goBack() {
        switch(this.category){
          case "SUBJECT":
            this.$router.push({ name: 'home-subjectform', params: { }})
            break;
          case "PROJECT":
            this.$router.push({ name: 'home-projectform', params: { }})
            break;
          default:
            this.$router.push({ name: 'home-form', params: { }})
            break;
        }

        //this.$router.push({ name: 'home-form', params: { }})
      },
      getInfo(formid){
        if(!formid) return;
        this.$http.get('form/info',{params:{id:formid}})
        .then((res) => { 
          this.forminfo = res.data.info;
        });
      },

      //标签
      handleTagClose(tag){
        let arrycategory = this.forminfo.tags.split(',');        
        arrycategory.splice(arrycategory.indexOf(tag), 1);
        this.forminfo.tags= arrycategory.join(",");

        //删除
        this.saveTag(this.formid,this.forminfo.tags);

      },
      submitTag(){
        let tagname = this.taginputvalue;
        if(tagname){
          if(this.appendTag(tagname)){

            //增加
            this.saveTag(this.formid,this.forminfo.tags);

            this.taginputvalue = "";
            this.taginputvisible = false;
          }
        }
      },
      saveTag(formid,tags){
          this.$http.post('form/edittag',{formid:formid,tags:tags,category:this.category})
          .then((res)=>{
            this.getTagList();
          });
      },
      selectTag(tagname){
        this.taginputvalue = tagname;
        this.submitTag();
      },
      selectTagTable(row, col, evt) {
        console.log(row);
        this.selectTag(row.tagname);
      },
      appendTag(tagname){
        let arryTags=[];
        if(this.forminfo.tags){
          arryTags = this.forminfo.tags.split(','); 
          if(arryTags.indexOf(tagname) !=-1){
            //已存在
            return false;
          }
        }
        arryTags.push(tagname);
        this.forminfo.tags = arryTags.join(",");
        return true;
      },

      getTagList(){
        this.$http.get('tag/list',{params:{tagtype:'FORM_'+this.category,minnum:1}}).then((res)=>{
          if(!res) return;
          this.tagtemplates.mytags = res.data.list;
        })
      },
      getTagTemplateList(){
        this.$http.get('tag/templatelist',{params:{tagtype:'icd11'}}).then((res)=>{
          if(!res) return;
          this.tagtemplates.icd11 = res.data.list;
        })
      },
    }
  };
</script>

<style>
/* .el-header {
  height:50px;
  padding-top:0px;
} */
</style>